import { render } from "./IntroductionPopup.vue?vue&type=template&id=dd31b322&scoped=true"
import script from "./IntroductionPopup.vue?vue&type=script&lang=js"
export * from "./IntroductionPopup.vue?vue&type=script&lang=js"

import "./IntroductionPopup.vue?vue&type=style&index=0&id=dd31b322&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd31b322"]])

export default __exports__